// extracted by mini-css-extract-plugin
export default {"alert":"cipm5hNMphJgcTdW3J4b"};